import { render, staticRenderFns } from "./DeliveryAdviceDetails.vue?vue&type=template&id=5ea243c5&scoped=true"
import script from "./DeliveryAdviceDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryAdviceDetails.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAdviceDetails.vue?vue&type=style&index=0&id=5ea243c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea243c5",
  null
  
)

export default component.exports